import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from './shared/theme/ThemeContext';
import { useI18n } from './shared/i18n/I18nContext';
import { useAuth } from './features/auth/logic/authProvider';
import Routes from './shared/routing/routes';
import Logo from './shared/ui/Logo';
// import TextSizeControl from './shared/ui/TextSizeControl';
import './AppShell.css';

const AppShell = ({ children }) => {
  const { theme, isDarkMode, toggleTheme } = useTheme();
  const { locale, setLocale, t, supportedLocales } = useI18n();
  const { isAuthenticated, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    setIsMenuOpen(false);
    navigate(Routes.login);
  };

  const renderHeaderControls = (className = 'app-shell__controls') => (
    <div className={className}>
      {/* <TextSizeControl /> */}
      <button type="button" className="app-shell__button" onClick={toggleTheme}>
        {isDarkMode ? 'Light Mode' : 'Dark Mode'}
      </button>
      <select
        className="app-shell__select"
        value={locale}
        onChange={(event) => setLocale(event.target.value)}
      >
        {supportedLocales.map((localeCode) => (
          <option key={localeCode} value={localeCode}>
            {localeCode.toUpperCase()}
          </option>
        ))}
      </select>
      {isAuthenticated && (
        <button type="button" className="app-shell__logout" onClick={handleLogout}>
          {t('logout') || 'Logout'}
        </button>
      )}
    </div>
  );

  return (
    <div
      className="app-shell"
      dir={locale === 'ar' ? 'rtl' : 'ltr'}
      style={{ background: theme.background, color: theme.text }}
    >
      <header className="app-shell__header" style={{ borderColor: theme.border }}>
        <div className="app-shell__brand">
          <Logo className="app-shell__logo" alt={t('appName') || 'Crew Core'} variant="named" size={220} />
        </div>

        {renderHeaderControls()}
        <button
          type="button"
          className="app-shell__menu-button"
          aria-label="Open menu"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen(true)}
        >
          <span />
          <span />
          <span />
        </button>
      </header>

      {isMenuOpen && (
        <div className="app-shell__menu-backdrop" role="presentation" onClick={() => setIsMenuOpen(false)}>
          <div
            className="app-shell__menu-dialog"
            role="dialog"
            aria-modal="true"
            aria-label="App menu"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="app-shell__menu-close"
              aria-label="Close menu"
              onClick={() => setIsMenuOpen(false)}
            >
              ×
            </button>
            {renderHeaderControls('app-shell__menu-controls')}
          </div>
        </div>
      )}

      <main className="app-shell__main">{children}</main>
    </div>
  );
};

export default AppShell;
